import { useReducer, useEffect, useContext } from 'react'
import {
    Grid,
    UniversalDataTable,
    UniversalModal,
    UniversalToolBar,
    UniversalLoadingCircle,
    UniversalExcelExport,
    FormSection,
} from '../../../../UniversalComponents'
import {
    CircularProgress,
    IconButton,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material'
import {
    PersonAdd as PersonAddIcon,
    Delete as DeleteIcon,
    Archive as ArchiveIcon,
    ArrowOutward as ArrowOutwardIcon,
    Restore,
    DownloadForOffline as DownloadForOfflineIcon,
} from '@mui/icons-material'
import {
    getUserProfiles,
    activateUserProfiles,
    getBoatUsers,
} from '../../../../../apiRoutes'
import {
    handleActivation,
    standardColumnMapper,
} from '../../../../../utilities/functionTools'
import { ToastMessage } from '../../../../../context/ToastPopUpContext'
import { useMinimizer } from '../../../../../context/MinimizeContext'
import { useAuth } from '../../../../../context/AuthenticationContext'
import { usePermissions } from '../../../../../context/AuthenticationContext'
import { useSocket } from '../../../../../context/SocketContext'
import UserProfileForm from '../../../Users/UserProfiles/UserProfileForm'
import UserForm from '../../../Users/UserAdmin/UserForm'
import { permissionsCheck } from '../../../../../utilities/functionTools'

const today = new Date().toISOString().substring(0, 10)

const BoatUsers = ({ boatId, isDealer }) => {
    const { setUser, auth } = useAuth()
    const { username, userPreferences, userProfile } = auth
    const { superAdmin, userProfilePermissions } = userProfile

    const defaultState = {
        open: false,
        row: {},
        formCache: {},
        data: [],
        openFileNamer: false,
        activateData: {},
        viewDeactivated: false,
        excelExportName: '',
        excelSelectedRows: [],
        manufacturers: [],
        disableDeactivation: false,
    }
    const setToastMessage = useContext(ToastMessage)
    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)
    const { setMinimized } = useMinimizer()
    const { apiSocket } = useSocket()

    const { open, row, formCache, data, activateData, viewDeactivated } = state

    const getData = async (id) => {
        let boatUsers: any = []
        try {
            boatUsers = await getBoatUsers(id)

            if (boatUsers && boatUsers.length !== 0) {
                boatUsers = standardColumnMapper(defaultColumns, boatUsers)
            }

            setState({ data: boatUsers })
        } catch (err: any) {
            setToastMessage(err, 'error')
            console.error(err, 'error')
        }
    }

    const setViewDeactivated = () => {
        setState({ viewDeactivated: !viewDeactivated })
    }

    useEffect(() => {
        getData(boatId)
    }, [])

    const setModalVisbility = async (tableRow: any, newData: any) => {
        if (tableRow?.userProfileName) {
            setState({ row: tableRow, open: !open })
        } else {
            setState({
                row: defaultState.row,
                open: !open,
            })
        }
        getData(boatId)
    }

    const defaultColumns = ['userEmail', 'userFirstName', 'userLastName']

    const visibleColumns = ['userEmail', 'userFirstName', 'userLastName']

    const customColumnNames = ['email', 'first name', 'last name']

    const minimizeModal = () => {
        setMinimized(true, {
            title: formCache.userEmail
                ? `Edit: ${formCache.userEmail}`
                : 'Add New User',
            link: 'admin/users',
            data: formCache._id ? formCache : { ...formCache, id: 'newUser' },
            id: formCache._id ? formCache._id : 'newUser',
        })
        setState({ open: false, row: defaultState.row })
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <UniversalLoadingCircle
                    data={data}
                    reloadFunction={
                        !viewDeactivated
                            ? () => getData(true)
                            : () => getData(false)
                    }
                    customTimeoutMessage={
                        !viewDeactivated
                            ? 'No active users available.'
                            : 'No deactivated users available.'
                    }
                >
                    <UniversalDataTable
                        data={data}
                        visibleColumns={visibleColumns}
                        customColumnNames={customColumnNames}
                        checkboxSelection={false}
                        getRowData={(tableRow) => {
                            if (!isDealer) {
                                setState({ open: true, row: tableRow })
                            }
                        }}
                    />
                </UniversalLoadingCircle>
            </Grid>

            <UniversalModal
                title={
                    activateData.id
                        ? `User Profile: ${row.userProfileName}`
                        : 'User Profile'
                }
                timeStamp={`${
                    activateData.userEmail
                        ? ` Modified By: ${row.updatedBy} ${
                              row.updateAt
                                  ? `| Modified Date ${row.updateAt}`
                                  : ''
                          }  `
                        : ` Created by: ${username} | Modified Date: ${today} `
                }`}
                open={open}
                onClose={(tableRow) => setModalVisbility(tableRow, undefined)}
                wrapperStyle={{
                    margin: 'auto',
                    width: '90%',
                    marginTop: 5,
                }}
            >
                <UserForm
                    row={row}
                    formDescription={''}
                    onClose={(tableRow: any, newData?: any) =>
                        setModalVisbility(tableRow, newData)
                    }
                    saveCache={(data: any) => setState({ formCache: data })}
                    minimizeModal={minimizeModal}
                    userFormPermissionCheck={permissionsCheck(
                        userProfilePermissions,
                        'Users'
                    )}
                />
            </UniversalModal>
        </Grid>
    )
}

export default BoatUsers
